export default __webpack_public_path__ + "static/media/timem.fa926c2d.png";